export default __webpack_public_path__ + "static/media/under.ea87a443.png";